import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	goalCounterText: {
		id: 'servicedesk-sla-settings.header.goal-counter.goal-counter-text',
		defaultMessage: 'Goals in this project:',
		description: 'Text for Goal Counter',
	},
	goalCounterTextDesc: {
		id: 'servicedesk-sla-settings.header.goal-counter.goal-counter-text-desc',
		defaultMessage: 'of',
		description: 'Text for Goal Counter count',
	},
});
